import React from 'react'
import FirstPart from './FirstPart'
import SecondPart from './SecondPart'
import ThirdPart from './ThirdPart'
import "./footer.css"

export default function Footer() {
  return (
    <section id="footer">
        <FirstPart/>
        <SecondPart/>
        <ThirdPart/>
    </section>
  )
}
